import { render } from "./ChatUsers.vue?vue&type=template&id=50a52a50"
import script from "./ChatUsers.vue?vue&type=script&lang=js"
export * from "./ChatUsers.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__